export interface CloudQuote {
  providerName: string
  currency: string
  configured: boolean
  uploadsEnabled: boolean
  totalBytes: number
  objectCount: number
  totalGb: number
  storageCost: number
  writeCost: number
  providerCost: number
  markupPercent: number
  serviceMargin: number
  estimatedMonthlyPrice: number
  estimatedAnnualPrice: number
  exclusions: string[]
}

function quoteEndpoint() { return '/api/storage/quote' }

export async function getCloudQuote(totalBytes: number, objectCount: number) {
  const response = await fetch(quoteEndpoint(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ totalBytes, objectCount }),
  })
  const payload = await response.json() as CloudQuote & { error?: string }
  if (!response.ok) throw new Error(payload.error || 'No se pudo calcular la estimación de nube.')
  return payload
}

export async function uploadCloudBlob(sessionId: string, relativePath: string, blob: Blob) {
  const response = await fetch('/api/storage/upload-url', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sessionId, relativePath, contentType: blob.type || 'application/octet-stream' }),
  })
  const payload = await response.json() as { url?: string; key?: string; error?: string }
  if (!response.ok || !payload.url) throw new Error(payload.error || 'No se pudo preparar la carga cloud.')
  const uploaded = await fetch(payload.url, { method: 'PUT', headers: { 'Content-Type': blob.type || 'application/octet-stream' }, body: blob })
  if (!uploaded.ok) throw new Error(`El proveedor S3 rechazó la carga (${uploaded.status}).`)
  return payload.key ?? relativePath
}

export function formatCloudMoney(value: number, currency: string) {
  return new Intl.NumberFormat('es-ES', { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
}

export function formatCloudGb(value: number) {
  return new Intl.NumberFormat('es-ES', { maximumFractionDigits: 2 }).format(value)
}
